import { Tab } from "@mui/material";
import { lazy, useState } from "react";
import MyTabs from "src/components/layout/MyTabs/MyTabs";
import { useUserData } from "src/context/userContext";
import AdminPanel from "./adminPanel/AdminPanel";
import Admin_test from "./test/Admin_test";
import { LogIcon, TestIcon } from "src/components/icons/NavIcons";
import { AdminPanelIcon } from "src/components/icons/StepIcons";
import AuthAccess from "src/data/auth/authAccess/AuthAccess";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
import { a11yProps, TabPanel } from "src/components/js/Statics";
const LogsCore = lazy(() => import("./logs/LogsCore"));

export default function AdminLayout() {
  const { user, userAsiakas } = useUserData();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <AuthAccess page="admin" user={user} userAsiakas={userAsiakas} showError>
      <div>
        <MyTabs value={tabValue} onChange={handleTabChange} centered>
          <Tab
            label={
              <div className="spaceBetween">
                <AdminPanelIcon /> Admin
              </div>
            }
            {...a11yProps(0)}
          />
          <Tab
            label={
              <div className="spaceBetween">
                <TestIcon /> Test
              </div>
            }
            {...a11yProps(1)}
          />
          <Tab
            label={
              <div className="spaceBetween">
                <LogIcon /> Logs
              </div>
            }
            {...a11yProps(2)}
          />
        </MyTabs>
        <TabPanel value={tabValue} index={0}>
          <AdminPanel />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <Admin_test />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <LazyLoader>
            <LogsCore />
          </LazyLoader>
        </TabPanel>
      </div>
    </AuthAccess>
  );
}
